export interface GymTier {
  id: string;
  name: string;
  tagline: string;
  priceINR: number;
  priceUSD: number;
  period: string;
  badge?: string;
  features: string[];
  highlightColor: string;
}

export interface GymCoach {
  id: string;
  name: string;
  title: string;
  specialty: string;
  certifications: string;
}

export interface GymFacility {
  id: string;
  name: string;
  category: string;
  description: string;
  specs: string[];
  hours: string;
}

export const GYM_TIERS: GymTier[] = [
  {
    id: "tier-black",
    name: "Apex Black Card (All-Access)",
    tagline: "Unrestricted club access, unlimited recovery spa & monthly master coaching",
    priceINR: 145000,
    priceUSD: 1850,
    period: "Annually",
    badge: "Most Exclusive",
    highlightColor: "from-amber-500 to-amber-600",
    features: [
      "24/7 Access to all Olympic lifting bays and strength laboratories",
      "Unlimited Cold Plunge, Infrared Sauna, and Cryotherapy suites",
      "Quarterly 3D DEXA & InBody 770 Biometric Body Composition Scans",
      "4 Monthly 1-on-1 Sessions with an assigned Master Strength Coach",
      "Dedicated executive locker room suite & complimentary laundry valet",
      "Unlimited guest day passes (up to 4 per calendar month)",
    ],
  },
  {
    id: "tier-performance",
    name: "Executive Performance",
    tagline: "Peak hours access, performance group academies, and recovery lounge",
    priceINR: 95000,
    priceUSD: 1200,
    period: "Annually",
    badge: "Popular",
    highlightColor: "from-emerald-500 to-emerald-600",
    features: [
      "Full access to strength, cardio, and functional turf arenas (05:00 - 23:00)",
      "Access to Infrared Sauna & Contrast Bath lounges (3x/week)",
      "Bi-annual InBody 770 Biometric Scans & Macro Nutritional Guidance",
      "2 Monthly 1-on-1 Sessions with a Certified Strength Coach",
      "Access to all signature Hyrox & High-Intensity Conditioning classes",
    ],
  },
  {
    id: "tier-conditioning",
    name: "Strength & Conditioning",
    tagline: "Essential strength platform, modern functional turf, and conditioning",
    priceINR: 65000,
    priceUSD: 820,
    period: "Annually",
    highlightColor: "from-blue-500 to-blue-600",
    features: [
      "Unrestricted gym floor & cardio mezzanine access",
      "Complimentary baseline InBody 770 scan upon onboarding",
      "Locker room & private shower amenities",
      "Access to Iron & Pulse mobile workout tracking app",
    ],
  },
];

export const GYM_COACHES: GymCoach[] = [
  {
    id: "coach-1",
    name: "Marcus Vance",
    title: "Head of Strength & Athletic Performance",
    specialty: "Olympic Weightlifting & Powerlifting Prep",
    certifications: "CSCS, USAW Level 2, Ex-National Powerlifting Champion",
  },
  {
    id: "coach-2",
    name: "Elena Rostova",
    title: "Director of Biomechanics & Functional Rehab",
    specialty: "Post-Rehab Spine & Joint Mobility Conditioning",
    certifications: "DPT, FMS Level 2, Precision Nutrition Master Coach",
  },
  {
    id: "coach-3",
    name: "Devrath Singh",
    title: "Senior Conditioning Specialist",
    specialty: "Hyrox Pro Coaching & High-Altitude Aerobic Engine",
    certifications: "NSCA-CPT, Hyrox Master Trainer, Oxygen Advantage Coach",
  },
  {
    id: "coach-4",
    name: "Zara Kothari",
    title: "Recovery & Nervous System Specialist",
    specialty: "Contrast Hydrotherapy, Breathwork & Fascial Release",
    certifications: "CES, PRI Certified, Breathwork Facilitator",
  },
];

export const GYM_FACILITIES: GymFacility[] = [
  {
    id: "fac-1",
    name: "Olympic Lifting & Power Bay",
    category: "Heavy Strength",
    description: "6 Custom Eleiko competition platforms, calibrated stainless steel plates, and motorized power racks.",
    specs: ["Eleiko IWF Spec Bars", "Calibrated Steel Plates", "Dumbbells up to 75kg"],
    hours: "05:00 AM - 11:30 PM",
  },
  {
    id: "fac-2",
    name: "Biometric Diagnostics & InBody Lab",
    category: "Health Tech",
    description: "Medical-grade clinical assessments measuring visceral fat, segmental muscle mass, and metabolic rate.",
    specs: ["InBody 770 Analyzer", "VO2 Max Sub-maximal Testing", "Dynamometer Grip Testing"],
    hours: "By Coach Appointment",
  },
  {
    id: "fac-3",
    name: "Cryotherapy & Thermal Recovery Spa",
    category: "Regeneration",
    description: "Full-body sub-zero cryotherapy chamber (-110°C), 4°C Finnish cold plunge tubs, and cedar infrared saunas.",
    specs: ["Full-body Cryo Chamber", "Ice Plunge Pools", "Clearlight Infrared Saunas"],
    hours: "06:00 AM - 10:30 PM",
  },
];

export const TIME_PREFERENCES = [
  "Early Morning (06:00 AM - 08:30 AM)",
  "Morning Peak (08:30 AM - 11:00 AM)",
  "Mid-day Executive (12:00 PM - 03:00 PM)",
  "Evening Prime (05:30 PM - 08:30 PM)",
  "Night Owl (08:30 PM - 11:00 PM)",
];

export const FITNESS_GOALS = [
  "Hypertrophy & Elite Muscle Building",
  "Olympic Weightlifting & Pure Strength",
  "Athletic Speed, Agility & Hyrox Conditioning",
  "Executive Fat Loss & Longevity Optimization",
  "Spine/Joint Rehabilitation & Mobility",
];
